import React, { type ComponentPropsWithoutRef } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { ChevronRightIcon } from '@/icons';
import { type FeaturedPeriod, FeaturedPeriods } from '@/module/featured/featuedQuiz.const';
import { useMoveFeaturedPage } from '@/module/featured/hook/useMoveFeaturedPage';
import { getSafeSchoolNameTKey } from '@/shared/category/getSafeSchoolNameTKey';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
type FeaturedHeaderProps = {
  activeTab: FeaturedPeriod;
  onClickTabButton: (tab: FeaturedPeriod) => void;
  schoolType: string;
};
export const FeaturedHeader = (props: FeaturedHeaderProps) => {
  const {
    t
  } = useTranslation(['common']);
  const moveFeaturedPage = useMoveFeaturedPage(props.schoolType, props.activeTab);
  return <div className={'flex w-full flex-col items-start gap-xs self-stretch px-xs py-none'} data-sentry-component="FeaturedHeader" data-sentry-source-file="FeaturedHeader.tsx">
      <div className={'flex w-full justify-between'}>
        <div className={'flex flex-1 items-center gap-3xs pl-3xs text-body-lg-bold text-default'}>
          <span className={'text-strong'}>
            {t(getSafeSchoolNameTKey(props.schoolType))}
          </span>{' '}
          <span>{t('common:category.popular')}</span>
        </div>
        <Button size={'xs'} onClick={() => moveFeaturedPage()} variant={'transparent'} intent={'neutral'} className="px-0" data-sentry-element="Button" data-sentry-source-file="FeaturedHeader.tsx">
          <ChevronRightIcon fill={ICON_COLOR.neutral} size={'sm'} data-sentry-element="ChevronRightIcon" data-sentry-source-file="FeaturedHeader.tsx" />
        </Button>
      </div>
      <FeaturedTab {...props} data-sentry-element="FeaturedTab" data-sentry-source-file="FeaturedHeader.tsx" />
    </div>;
};
const FeaturedTab = (props: FeaturedHeaderProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className={'flex w-full items-center gap-4xs  rounded-sm border border-opacity-assistive bg-neutral p-4xs '} data-sentry-component="FeaturedTab" data-sentry-source-file="FeaturedHeader.tsx">
      {FeaturedPeriods.map(period => <FeaturedTabButton key={period.value} active={props.activeTab === period.value} onClick={() => {
      props.onClickTabButton(period.value);
      period.track({
        schoolType: props.schoolType,
        location: 'public'
      });
    }}>
          {t(period.name)}
        </FeaturedTabButton>)}
    </div>;
};
const FeaturedTabButton = (props: ComponentPropsWithoutRef<'button'> & {
  active: boolean;
}) => {
  const {
    active,
    ...rest
  } = props;
  return <Button className={cn('flex-1', active ? 'bg-default hover:bg-default hover:bg-opacity-1 text-default border-alternative shadow-xs' : 'border border-transparent border-solid')} variant={props.active ? 'contained' : 'transparent'} intent={'neutral'} size={'xs'} {...rest} data-sentry-element="Button" data-sentry-component="FeaturedTabButton" data-sentry-source-file="FeaturedHeader.tsx" />;
};